// P1-007: Overload Calculator — compute overload value and classify severity
// Formula (GDD SS4.2.3):
//   overloadValue = max(0, powerUsage - powerLimit) + max(0, heatGen - cooling)
//   Classify: none(<=0), light(1-5), medium(6-10), heavy(>10)

export type OverloadLevel = 'none' | 'light' | 'medium' | 'heavy';

export interface OverloadResult {
  overloadValue: number;
  overloadLevel: OverloadLevel;
}

export const OverloadCalculator = {
  /**
   * Calculate raw overload value from hardware stats.
   */
  calculate(
    powerUsage: number,
    powerLimit: number,
    heatGen: number,
    cooling: number,
  ): number {
    return Math.max(0, powerUsage - powerLimit) + Math.max(0, heatGen - cooling);
  },

  /**
   * Classify overload value into severity level.
   *   none:   <= 0
   *   light:  1 - 5
   *   medium: 6 - 10
   *   heavy:  > 10
   */
  classify(value: number): OverloadLevel {
    if (value <= 0) return 'none';
    if (value <= 5) return 'light';
    if (value <= 10) return 'medium';
    return 'heavy';
  },

  /**
   * Convenience: calculate + classify in one call.
   */
  evaluate(
    powerUsage: number,
    powerLimit: number,
    heatGen: number,
    cooling: number,
  ): OverloadResult {
    const overloadValue = OverloadCalculator.calculate(powerUsage, powerLimit, heatGen, cooling);
    return {
      overloadValue,
      overloadLevel: OverloadCalculator.classify(overloadValue),
    };
  },
};
